module.exports = __webpack_public_path__ + "assets/img/b64d601fd61bdbe736b3ca8341c5a733.png";